import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import {
    dayjs
} from 'element-plus';

// 扁平化树形数组（无限层级）
const flatten = (arr, ret = []) => {
    arr.forEach(node => {
        ret.push(node);
        if (node.children?.length) flatten(node.children, ret);
    });
    return ret;
};

// 字段映射
const createRows = (columns, row) =>
    columns.reduce((acc, col) => {
        let v = row[col.property];
        if (Array.isArray(v)) v = v.join(',');
        else if (v == null) v = ''; // 统一把 null/undefined 转空串
        acc[col.label] = v;
        return acc;
    }, {});

/**
 * 导出 Excel
 * @param {Array} fileList   源数据（可嵌套 children）
 * @param {Array} tableHead  列配置 [{ property, label, export }, ...]
 * @param {String} title     文件名前缀
 * @returns {Promise}        下载完成或失败
 */
const jsonToExcel = (fileList, tableHead, title = '默认标题') => {
    const exportCols = tableHead.filter(c => c.export);
    const header = exportCols.map(c => c.label);

    const exportData = flatten(fileList).map(row => createRows(exportCols, row));

    const sheet = XLSX.utils.json_to_sheet(exportData, {
        header
    });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, sheet, 'data');

    const wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'array'
    });

    const fileName = `${title}_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;

    return new Promise((resolve, reject) => {
        try {
            FileSaver.saveAs(new Blob([wbout], {
                type: 'application/octet-stream'
            }), fileName);
            resolve();
        } catch (e) {
            console.error(e);
            reject(new Error('Excel 导出失败：' + e.message));
        }
    });
};

export default jsonToExcel;